module.exports = __webpack_public_path__ + "img/kyIcon_1.073592bd.png";